
const enums = { 'COMBINATION': { 'text': '组合', 'value': 1 },
  'MAGNIFICATION': { 'text': '倍率', 'value': 2 },
  'MAGNIFICATION2': { 'text': '倍率2', 'value': 3 }

}
export default enums
